/**
 * Métadonnées d'affichage d'une quête (icône + libellé), partagées par la
 * liste du dashboard et l'écran de progression post-leçon Reps.
 *
 * Les icônes reprennent EXACTEMENT celles de QuestItem : une même quête doit
 * se reconnaître au premier coup d'œil, qu'elle soit vue sur le dashboard ou
 * juste après une leçon.
 */

const ICONS = {
    xp_gain: "/static/icons/xp.svg",
    time_spent: "/static/icons/clock.svg",
    sessions_completed: "/static/icons/booknote.svg",
    perfect_quiz: "/static/icons/perfect-quiz.svg",
    quiz_success_rate: "/static/icons/quiz.svg",
    complete_part: "/static/icons/part.svg",
    time_based_session: "/static/icons/campfire.svg",
    community_post: "/static/icons/glob-community.svg",
};

/** Chemin de l'icône 16px d'une quête (repli : la punaise, comme QuestItem). */
export function questIconSrc(quest) {
    return ICONS[quest?.type] || "/static/icons/pin.svg";
}

/**
 * Clé i18n du libellé. questKey d'abord (une même mécanique peut servir
 * plusieurs quêtes), type ensuite. Couvre les quêtes Reps, que la table de
 * QuestItem ne connaît pas encore.
 */
export function questLabelKey(quest) {
    switch (quest?.questKey) {
        case "daily_xp":
            return "quest_xp_gain";
        case "daily_time":
            return "quest_time_spent";
        case "daily_sessions":
            return "quest_sessions_completed";
        case "quiz_success":
            return "quest_quiz_success_rate";
        case "daily_reps_lessons":
        case "reps_lessons_hard":
            return "quest_lessons_completed";
        case "reps_perfect_lesson":
            return "reps_quest_perfect_lesson";
        case "reps_evening_lesson":
            return "reps_quest_evening_lesson";
        default:
            break;
    }
    switch (quest?.type) {
        case "xp_gain":
            return "quest_xp_gain";
        case "time_spent":
            return "quest_time_spent";
        case "sessions_completed":
            return "quest_sessions_completed";
        case "lessons_completed":
            return "quest_lessons_completed";
        case "perfect_quiz":
            return "quest_perfect_quiz";
        case "quiz_success_rate":
            return "quest_quiz_success_rate";
        case "complete_part":
            return "quest_complete_part";
        case "time_based_session":
            return "quest_evening_session";
        case "community_post":
            return "quest_community_post";
        case "perfect_lesson":
            return "reps_quest_perfect_lesson";
        case "evening_lesson":
            return "reps_quest_evening_lesson";
        default:
            return "quest_lessons_completed";
    }
}

/** Nom du mois dans la langue de l'interface (badge du mois). */
const MONTHS = {
    fr: [
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre",
    ],
    en: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ],
};

export function monthName(month, locale) {
    const list = locale === "en" ? MONTHS.en : MONTHS.fr;
    return list[Math.min(12, Math.max(1, Number(month) || 1)) - 1];
}
